import { ref, type Ref } from "vue";
import type { IIconProps } from "@magnit/icons/src/components/VIcon/VIcon.types";
import { useMemoize } from "@vueuse/core";

const fetchMemoizedIcon = useMemoize(async (path: string) => {
  const result = await fetch(path);
  if (result.status === 200) return await result.text();
  throw new Error(result.statusText);
});

export default (
  name: IIconProps["name"],
  project: IIconProps["project"],
  isAsyncIcon: Ref<boolean>,
) => {
  const loadedIcon = ref<null | string>(null);

  const fetchAsyncIcon = async () => {
    loadedIcon.value = null;
    if (!isAsyncIcon.value) return;
    try {
      loadedIcon.value = await fetchMemoizedIcon(
        `/assets/svg/icons/${project}/${name}.svg`,
      );
    } catch (err) {
      errorLoading(err);
    }
  };

  const errorLoading = (err: unknown) => {
    loadedIcon.value = null;
    console.error("VIcon:fetchAsyncIcon не удалось загрузить иконку", {
      name,
      err,
    });
  };

  return {
    loadedIcon,
    fetchAsyncIcon,
  };
};
